export default "__VITE_ASSET__Br$rCk9u__"